<template>
    <div :class="{'bordered': type === 'bordered'}" class="social-group">
        <Social
            v-for="(social,index) in socialGroup"
            :key="`${social.platform}-${index}`"
            :icon="`${social.platform}shop`"
            :size="size"
            :followers="social.followers | kFormatter(social.followers)"
            :type="type"
        />
    </div>
</template>

<script>
import { kFormatter } from '../../core/filters'
import Social from './Social'
export default {
    name: 'SocialGroup',
    components: {
        Social
    },
    props: {
        socialGroup: {
            type: Array,
            default: () => []
        },
        size: {
            type: String,
            default: () => 'md'
        },
        type: {
            type: String,
            default: () => 'default'
        }
    },
    filters: {
        kFormatter
    }
}
</script>

<style lang="scss" scoped>
$border: 1px solid #CBD5E0;
$radius: 8px;
$padding: 12px 18px 12px 18px;
.social-group {
    display: flex;
    align-items: center;
    &.bordered {
        padding: $padding;
        border: $border;
        border-radius: $radius;
    }
}
</style>>
